import { render } from "./HeaderPage.vue?vue&type=template&id=65afac32"
import script from "./HeaderPage.vue?vue&type=script&lang=js"
export * from "./HeaderPage.vue?vue&type=script&lang=js"

import "./HeaderPage.vue?vue&type=style&index=0&id=65afac32&lang=css"

import exportComponent from "D:\\allNewWeb\\ant-vue\\daifanew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__